$shm_hitalama_map_widget_float_entity $shm_hitalama_map_widget_float_layout_vert
	padding_top 52
	padding_bottom 1
	padding_left 1
	padding_right 1
	gap 1
	add_types /
		\entity_field
	auto /
		^
		<= schema_widgets_auto null
	controls /
		<= Entity_head $mol_view
			sub /
				<= Entity_name $mol_string
					value? <=> title?
				<= Record_count $mol_view
					sub / <= record_count_title \0 записей
				<= Add_field $mol_button_minor
					hint \Добавить свойство
					sub / <= Add_field_icon $mol_icon_plus
					click? <=> field_add? null
				<= Open_table $mol_button_minor
					hint \Открыть таблицу
					sub / <= Open_table_icon $mol_icon_table
					click? <=> table_open? null
		^
